<template>
  <div class="app bg-gray" id="register-dateDoctorSchedule">
    <!-- 时间选择 -->
    <time-table
      @change="loadDoctorSchedule"
      :areaId="registInfo.area.areaId"
      :deptId="registInfo.depart.deptId"
    ></time-table>
    <!-- 医生列表 -->
    <scroll id="has-schedule" @refresh="loadDoctorSchedule" style="top: 4.2rem">
      <no-record
        :condition="schedules"
        tips="当天没有医生排班，请选择其他日期"
        id="register-dateDoctorSchedule-norecord"
      ></no-record>
      <ul class="">
        <li
          @click="onSelected(item, index, $event)"
          v-for="(item, index) in schedules"
          class="doctor-section"
          :id="'register-dateDoctorSchedule-list-' + index"
        >
          <div class="doctor-schedule-info">
            <div
              class="head doc-header"
              v-bind:style="{
                backgroundImage:
                  'url(' +
                  (item.doctAvatar
                    ? item.doctAvatar
                    : '../../../static/img/ico-doctor.png') +
                  ')',
              }"
            >
              <!-- 门诊类型标签 -->
              <span
                v-if="item.typeId === '849772'"
                class="type-tag tag-putong"
                >{{ item.typeName }}</span
              >
              <span
                v-if="item.typeId === '643075'"
                class="type-tag tag-zhuanjia"
                >{{ item.typeName }}</span
              >
            </div>
            <div class="info">
              <p class="f-large ellipsis">
                {{ item.rankName }}&nbsp;{{ item.doctName }}
              </p>
              <!-- 第二行，挂号金额和剩余号源同一行 -->
              <div
                class="flex-row flex-align-center arr-row"
                style="border-bottom: none"
              >
                <p class="flex-1 f-small ellipsis">
                  <span class="f-minor" style="margin-right: 0.25rem"
                    >挂号金额：</span
                  ><span class="f-strongest">{{ item.fee | formatFee }}</span>
                </p>
                <p class="f-large f-minor">
                  剩 <span class="f-strong">{{ item.restCount }}</span> 号
                </p>
              </div>
              <!-- 第三行，医生介绍和更多同一行 -->
              <div
                class="flex-row flex-align-end"
                @click="openRemain(item, $event)"
              >
                <p
                  :id="'doctor-remain-' + index"
                  class="flex-1 f-small f-minor"
                  :class="
                    item.showDetailRemain
                      ? 'doctor-remain-open'
                      : 'doctor-remain-close'
                  "
                >
                  {{ item.doctDesc ? item.doctDesc : "暂无介绍" }}
                </p>
                <span
                  v-show="item.hasMoreRemain"
                  :class="item.showDetailRemain ? 'arrow-up' : 'arrow-down'"
                ></span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </scroll>
  </div>
</template>
<script>
import TimeTable from 'TimeTable';
import NoRecord from 'NoRecord';
import registerService from 'register.service'
export default {
  components: {
    TimeTable,
    NoRecord
  },
  beforeCreate () {
    var params = this.$store.state.paramModule.param.register;
    document.title = params.depart.deptName;
    //        this.$router.currentRoute.meta.title = params.depart.deptName;
    // 解决document.title 在 ios 下不生效bug方案 ios内生效
    //        const mobile = navigator.userAgent.toLowerCase();
    //        const length = document.querySelectorAll('iframe').length;
    //        if (/iphone|ipad|ipod/.test(mobile) && !length) {
    //            const iframe = document.createElement('iframe');
    //            iframe.style.cssText = 'display: none; width: 0; height: 0;';
    //            iframe.setAttribute('src', 'about:blank');
    //            iframe.addEventListener('load', () => {
    //                setTimeout(() => {
    //                    iframe.removeEventListener('load', false);
    //                    document.body.removeChild(iframe);
    //                }, 0);
    //            });
    //            document.body.appendChild(iframe);
    //        }
  },
  data () {
    var params = this.$store.state.paramModule.param.register;
    return {
      registInfo: params,
      hospitalName: JSON.parse(localStorage.selectedHospital).hospitalName || "",
      schedules: [],
      departName: params.depart.deptName,
    };
  },
  methods: {
    openRemain (item, event) {
      // 如果该医生简介可以拓展，则该点击事件阻止冒泡
      if (item.hasMoreRemain) {
        event.cancelBubble = true
      }
      item.showDetailRemain = !item.showDetailRemain
    },
    onSelected: function (item) {
      this.$store.commit('updateParam', {
        namespace: 'register',
        doc: item
      });
      this.$router.push({
        name: 'timeSchedule'
      });
    },

    loadDoctorSchedule: function () {
      this.schedules = this.constant.ARRAY_CLEAN;
      var params = this.$store.state.paramModule.param.register;
      var requestParams = {
        areaId: params.area.areaId,
        deptId: params.depart.deptId,
        regDate: params.date.value
      }
      registerService.loadDoctorSchedule(requestParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        const items = res.data || []
        if (items.length > 0) {
          for (let i = 0; i < items.length; i++) {
            items[i].showDetailRemain = false
            items[i].hasMoreRemain = true
          }
        }
        this.schedules = items
        // 等doom元素绘制完成后，判断每个简介是否超出(如果不超出则不需要拓展)
        this.$nextTick(() => {
          if (this.schedules.length > 0) {
            for (let i = 0; i < this.schedules.length; i++) {
              const id = 'doctor-remain-' + i
              let clientHeight = document.getElementById(id).clientHeight
              let scrollHeight = document.getElementById(id).scrollHeight
              this.schedules[i].hasMoreRemain = clientHeight < scrollHeight
            }
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" >
@import "../../../static/sass/_variable.scss";
.doctor-section {
  position: relative;
  @include border(bottom);
  background: #fff;
}
.doctor-schedule-info {
  @include display-flex();
  padding: 0.4rem 0 0.4rem 0.75rem;
  .head {
    width: 80px;
    height: 80px;
  }
  .info {
    @include flex(1);
    width: 1px;
    padding-left: 10px;
    .arrow-down {
      margin-right: 0.5rem;
      margin-bottom: 2px;
      width: 15px;
      height: 8px;
      background: url(../../../static/img/arrow-down.png) 100% 100% no-repeat;
      background-size: 100%;
    }
    .arrow-up {
      margin-right: 0.5rem;
      margin-bottom: 2px;
      width: 15px;
      height: 8px;
      background: url(../../../static/img/arrow-up.png) 100% 100% no-repeat;
      background-size: 100%;
    }
  }
  .doctor-remain-close {
    @include maxLine-ellipsis(2);
  }
  .doctor-remain-open {
    @include maxLine-ellipsis(99);
  }
}
</style>



// WEBPACK FOOTER //
// DateDoctorSchedule.vue?54a1f721